import React, { useContext } from "react";
import "./Dropdown.css";
import GermanFlag from "../../assets/images/germany.png";
import FrenchFlag from "../../assets/images/france.png";
import { LanguageContext } from "../../context/LanguageContext";
const Dropdown = ({ open }) => {
  const { language, setLanguage } = useContext(LanguageContext);

  return (
    <div>
      {open === true ? (
        <div className="dropdown_container">
          <div
            className="dropdown_item"
            onClick={() =>
              window.scrollTo({
                top: document.getElementsByClassName("functions_container")[0]
                  .offsetTop,
                behavior: "smooth",
              })
            }
          >
            <button className="navbar_link">
              {language === "german" ? "Funktion" : "Les fonctions"}
            </button>
          </div>
          <div
            className="dropdown_item"
            onClick={() =>
              window.scrollTo({
                top: document.getElementsByClassName("partners_container")[0]
                  .offsetTop,
                behavior: "smooth",
              })
            }
          >
            <button className="navbar_link">
              {language === "german" ? "Partner" : "Partenaires"}
            </button>
          </div>
          {/*<div
            className="dropdown_item"
            onClick={() =>
              window.scrollTo({
                top: document.getElementsByClassName("statements_container")[0]
                  .offsetTop,
                behavior: "smooth",
              })
            }
          >
            <button className="navbar_link">
              {language === "german" ? "Statements" : "Déclaration"}
            </button>
          </div>*/}
          <div
            className="dropdown_item"
            onClick={() =>
              window.scrollTo({
                top: document.getElementsByClassName("contact_container")[0]
                  .offsetTop,
                behavior: "smooth",
              })
            }
          >
            <button className="navbar_link">
              {" "}
              {language === "german" ? "Kontakt" : "Contact"}
            </button>
          </div>
          <div className="dropdown_item">
            <img
              src={language === "german" ? FrenchFlag : GermanFlag}
              alt="lanugage_flag"
              className="language_flag"
              onClick={() => {
                const chosenLanugage =
                  language === "german" ? "french" : "german";
                window.localStorage.setItem("language", chosenLanugage);
                setLanguage(chosenLanugage);
              }}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Dropdown;
